import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import { EventBus } from "../../../event-bus";
import * as consts from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";

export const state = {
  clientIdentifyData: {},
  listCreditCards: []
};

export const getters = {
  [consts.GETTER_EXIST_CUSTOMER_IDENTIFY]: state => {
    return state.clientIdentifyData;
  },
  [consts.GETTER_LIST_CREDIT_CARDS]: state => {
    return state.listCreditCards;
  }
};

export const actions = {
  [consts.ACTION_GENERATE_CUSTOMER_IDENTIFY]: ({ commit }, options) => {
    let method = "POST";
    let url = getEndPoints().employers.generateCustomerIdentify;
    makeCall(url, buildOptions(method, options.clientSettingDTO), commit)
      .then(response => {
        if (response.error) {
          if (options.errorHandling) {
            options.errorHandling(response.error);
          }
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          commit(consts.MUTATION_SET_EXIST_CUSTOMER_IDENTIFY, response);
          options.verifyData(true);
          options.callback(response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [consts.ACTION_GET_EXIST_CUSTOMER_IDENTIFY]: ({ commit }, options) => {
    let method = "GET";
    let url = getEndPoints().employers.getExistCustomerIdentify.replace(
      ":clientId",
      options.clientId
    );
    makeCall(url, buildOptions(method, options), commit)
      .then(response => {
        if (response && response.id) {
          options.verifyData(true);
          commit(consts.MUTATION_SET_EXIST_CUSTOMER_IDENTIFY, response);
          if (options.callback) {
            options.callback();
          }
        } else {
          options.verifyData(false);
          commit(consts.MUTATION_SET_EXIST_CUSTOMER_IDENTIFY, response);
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [consts.ACTION_GET_LIST_CREDIT_CARDS]: ({ commit }, options) => {
    let method = "GET";
    let urlTemp = getEndPoints().employers.getListCreditCards.replace(
      ":customerIdentifier",
      options.customerIdentifier
    );
    let url = urlTemp.replace(":accountIdentifier", options.accountIdentifier);
    makeCall(url, buildOptions(method, options), commit)
      .then(response => {
        if (response) {
          commit(consts.MUTATION_SET_LIST_CREDIT_CARDS, response);
          if (options.callback) {
            options.callback();
          }
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [consts.ACTION_CREATE_CREDIT_CARD]: ({ commit }, options) => {
    let method = "POST";
    let url = getEndPoints().employers.regCreditCardForAccount;
    makeCall(url, buildOptions(method, options.creditCardObjPayload), commit)
      .then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback();
            options.afterCallback();
          }
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  },
  [consts.ACTION_ADD_FUND]: ({ commit }, options) => {
    let method = "POST";
    let url = getEndPoints().employers.addFund;
    makeCall(url, buildOptions(method, options.fundObjPayload), commit)
      .then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback();
            options.afterCallback();
          }
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) ||
            "Transaction cannot be processed at this time. Please try again later. For any concerns or assistance, please contact your support representative."
        );
      });
  },
  [consts.ACTION_UPDATE_THRESHOLD]: ({ commit }, options) => {
    let method = "POST";
    let url = getEndPoints().employers.updateThreshold;
    makeCall(url, buildOptions(method, options.clientIdentifyData), commit)
      .then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback();
          }
        }
      })
      .catch(function(response) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
  }
};

export const mutations = {
  [consts.MUTATION_SET_EXIST_CUSTOMER_IDENTIFY]: (
    state,
    clientIdentifyData
  ) => {
    state.clientIdentifyData = clientIdentifyData;
  },
  [consts.MUTATION_SET_LIST_CREDIT_CARDS]: (state, listCreditCards) => {
    state.listCreditCards = listCreditCards;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/client_rewards_setting/index.js